<div class="container">
  <div #mapContainer class="map-container"></div>

        
    <div #directionsPanel class="directions-panel">
        @if (!directionsResults) {
            <p>Calculating route...</p>
        }
    </div>
</div>